module.exports = __webpack_public_path__ + "static/media/CrousalItem1.235b8a55.png";